import React from 'react'
import { useLingui } from '@lingui/react/macro'
import { graphql, useLazyLoadQuery } from 'react-relay'

import { useParams } from 'react-router-dom'
import { YStack, useMedia } from 'tamagui'
import { GuildMetadata } from '@newComponents/Guild/GuildMetadata'
import { useScreenMessages } from '@data/i18n'

import { GuildNetworksSection } from './GuildNetworksSection'
import { GuildNetworkGuildsSection } from './GuildNetworkGuildsSection'

import { GuildNetworksScreenQuery } from './__generated__/GuildNetworksScreenQuery.graphql'

export const GuildNetworksScreen = () => {
  useScreenMessages(
    (locale) =>
      import(
        /* webpackChunkName: "locale-guild-networks-screen-[request]" */ `./locales/${locale}.po`
      )
  )
  const { t } = useLingui()
  const params = useParams()
  const media = useMedia()

  const data = useLazyLoadQuery<GuildNetworksScreenQuery>(
    graphql`
      query GuildNetworksScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on Guild {
            name

            ...GuildMetadata_guild
            ...GuildNetworksSection_guild
            ...GuildNetworkGuildsSection_guild
          }
        }
      }
    `,
    { id: params.actorId! }
  )

  if (data.nodeBySlugId?.__typename !== 'Guild') {
    return null
  }

  return (
    <>
      <GuildMetadata
        guild={data.nodeBySlugId}
        title={t`${data.nodeBySlugId.name} Network`}
      />

      <YStack gap='$5'>
        <GuildNetworksSection guild={data.nodeBySlugId} />

        <GuildNetworkGuildsSection guild={data.nodeBySlugId} />
      </YStack>
    </>
  )
}

export default GuildNetworksScreen
